import React, { useState } from "react";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../../config/firebase";
import { useNavigate } from "react-router-dom";
import "./AdminLogin.css";

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    if (!email || !password) return setError("Please enter email and password.");
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/dashboard");
    } catch (err) {
      setError("Invalid credentials. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    const emailForReset = email || window.prompt("Enter your admin email to receive a password reset link:");
    if (!emailForReset) return;
    try {
      await sendPasswordResetEmail(auth, emailForReset);
      alert("Password reset email sent. Check your inbox.");
    } catch (err) {
      alert("Failed to send reset email: " + err.message);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <h2>Admin Panel</h2>
          <p className="subtitle">Sign in to manage site content</p>
        </div>

        <form onSubmit={handleLogin} className="admin-login-form" aria-label="Admin sign in form">
          {error && <div className="login-error" role="alert">{error}</div>}

          <label className="input-label">
            <span>Email</span>
            <input
              type="email"
              value={email}
              placeholder="admin@example.com"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>

          <label className="input-label">
            <span>Password</span>
            <input
              type="password"
              value={password}
              placeholder="Enter your password"
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>

          <div className="form-actions">
            <button className="btn primary" type="submit" disabled={loading}>
              {loading ? "Signing in..." : "Login"}
            </button>
            <button type="button" className="forgot-link" onClick={handleForgotPassword}>
              Forgot password?
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;